/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

window.when('.js-product-atc-bar', () => {
    const el = document.querySelector('.js-product-atc-bar');
    const trigger = document.querySelector('.js-product-atc-bar-trigger');
    if(!el) return;
    const btn = el.querySelector('.js-btn');
    const target = document.querySelector('.js-product-atc-bar-target');
  
    btn.addEventListener('click', (e) => {
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
      e.preventDefault();
    });
  
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      const observer = new IntersectionObserver((entries) => {
        const showBar = (entries[0].boundingClientRect.y < 0);
        el.classList.toggle('is-visible', showBar);
      }, {
        threshold: 1.0,
        root: null,
      });
  
      observer.observe(trigger);
    }
  });